import { useEffect, useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

let openFn = null;

// In-app replacement for window.confirm — resolves true when the user confirms.
export function confirmAction(message, { title = "Are you sure?", confirmLabel = "Yes, delete" } = {}) {
  return new Promise((resolve) => (openFn ? openFn({ message, title, confirmLabel, resolve }) : resolve(window.confirm(message))));
}

export default function ConfirmHost() {
  const [req, setReq] = useState(null);
  useEffect(() => { openFn = setReq; return () => { openFn = null; }; }, []);
  const close = (ok) => { req?.resolve(ok); setReq(null); };
  return (
    <AlertDialog open={!!req} onOpenChange={(o) => { if (!o) close(false); }}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{req?.title}</AlertDialogTitle>
          <AlertDialogDescription data-testid="confirm-dialog-message">{req?.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-dialog-cancel" onClick={() => close(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-dialog-ok" className="bg-red-600 hover:bg-red-700" onClick={() => close(true)}>{req?.confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
